// COMPONENTS
import React from 'react';
import { Button, Flex, Modal } from '@bancobarigui/barihaus';
import img from '../../../../assets/img-modal/modal-image.png';

import { useNavigate } from 'react-router-dom';

import { ModalContentWrapper, ModalDivider, ModalDescription } from './styles';

interface IModalProposalAlreadyRegistered {
  open: boolean;
  onClose: () => void;
}

export const ModalProposalAlreadyRegistered = ({ open, onClose }: IModalProposalAlreadyRegistered) => {
  const navigate = useNavigate();

  return (
    <Modal
      open={open}
      className="proposal-already-registered"
      title="Essa proposta já foi registrada"
      onCancel={onClose}
      footer={
        <Flex gap={16}>
          <Button buttonColor="secondary" variant="outlined" onClick={onClose}>
            Fechar
          </Button>
          <Button buttonColor="primary" onClick={() => navigate('/manage-proposal')} type="primary">
            Gerenciar propostas
          </Button>
        </Flex>
      }
    >
      <ModalContentWrapper vertical align="center">
        <ModalDivider size="large" />
        <img src={img} alt="Proposal Already Registered" width="200px" />
        <ModalDescription>
          Os dados que você preencheu já constam em uma proposta em nosso sistema. Por favor, revise as informações ou,
          se preferir, entre em contato com nosso time de suporte para te ajudar.
        </ModalDescription>
      </ModalContentWrapper>
    </Modal>
  );
};

export default ModalProposalAlreadyRegistered;
